import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = {
  class: "page",
  id: "page"
};
const _hoisted_2 = {
  class: "section-md bg-transparent"
};
const _hoisted_3 = {
  class: "container"
};
const _hoisted_4 = {
  class: "row row-40 row-xl-55 row-xxl-100",
  "data-animate": "{\"class\":\"fadeInUpBig\"}"
};
const _hoisted_5 = {
  class: "thumbnail"
};
const _hoisted_6 = ["src"];
import { ref, onMounted, computed } from 'vue';
import { customerList } from '@/api/customer';
import { bannerList as bannerListHttp } from '@/api/home';
export default {
  __name: 'service',
  setup(__props) {
    const path = computed(() => {
      return process.env.VUE_APP_BASE_ADDRESS;
    });

    // 顶部图片
    const bg = ref('');
    const getBanner = async () => {
      const data = await bannerListHttp({
        type: 'service'
      });
      if (data?.length > 0) {
        for (const item of data) {
          if (!item.src.startsWith('http')) item.src = path.value + item.src;
        }
        bg.value = data[0]?.src;
      }
    };
    const list = ref([]);
    const getData = params => {
      customerList().then(res => {
        for (const item of res) {
          item.src = path.value + item.src;
        }
        list.value = res;
      });
    };
    onMounted(() => {
      getBanner();
      getData();
    });
    return (_ctx, _cache) => {
      const _component_Preload = _resolveComponent("Preload");
      const _component_Header = _resolveComponent("Header");
      const _component_Footer = _resolveComponent("Footer");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_Preload), _createElementVNode("div", _hoisted_1, [_createVNode(_component_Header, {
        title: "冀华伙伴",
        bg: bg.value
      }, null, 8, ["bg"]), _createElementVNode("section", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.value, item => {
        return _openBlock(), _createElementBlock("div", {
          class: "col-6 col-sm-6 col-lg-3",
          style: {
            "display": "flex",
            "justify-content": "center",
            "align-items": "center"
          },
          key: item.id
        }, [_createElementVNode("div", _hoisted_5, [_createElementVNode("img", {
          src: item.src,
          alt: "",
          width: "270"
        }, null, 8, _hoisted_6)])]);
      }), 128))])])]), _createVNode(_component_Footer)])], 64);
    };
  }
};